import { useQueryReceivedOrders } from "@features/orders/hooks/useQueryReceivedOrders";
import { useMarketplaceIdentity } from "@hooks/useMarketplaceIdentity";
import { useEffect, useMemo, useState } from "react";
import {
  getUnreadReceivedOrderIds,
  subscribeMyRequestsReadState,
} from "./myRequestsReadState";

/**
 * Incoming (Orders Received) requests the user has not opened on My Requests yet.
 */
export function useUnreadReceivedOrders() {
  const { sub, isAuthenticated } = useMarketplaceIdentity();
  const ordersEnabled = Boolean(isAuthenticated && sub);
  const [readStateVersion, setReadStateVersion] = useState(0);

  useEffect(
    () =>
      subscribeMyRequestsReadState(() => {
        setReadStateVersion((value) => value + 1);
      }),
    []
  );

  const { data: receivedOrders, isLoading, isSuccess } = useQueryReceivedOrders({
    enabled: ordersEnabled,
  });

  const unreadOrderIds = useMemo(() => {
    void readStateVersion;
    return getUnreadReceivedOrderIds(sub, receivedOrders);
  }, [sub, receivedOrders, readStateVersion]);

  return {
    unreadOrderIds,
    unreadOrderIdSet: useMemo(() => new Set(unreadOrderIds), [unreadOrderIds]),
    hasUnread: unreadOrderIds.length > 0,
    receivedOrders,
    isLoading,
    isSuccess,
    sub,
    ordersEnabled,
  };
}
